import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import {
  totalSpentGreaterThanFromModel,
  validateTotalSpentGreaterThanCondition,
  type TotalSpentGreaterThanState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const TOTAL_SPENT_GREATER_THAN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<TotalSpentGreaterThanState>
  >,
): ConditionType<
  TotalSpentGreaterThanState,
  ModelCondition.TotalSpentGreaterThan
> => ({
  name: "Total spent greater than",
  description(state) {
    return `More than $${+state} spent`;
  },
  Details(props: ConditionTypeDetailsProps<TotalSpentGreaterThanState>) {
    return React.createElement(Details, props);
  },
  empty: String(0),
  fromModel(model) {
    return totalSpentGreaterThanFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.TOTAL_SPENT_GREATER_THAN, totalSpent: state };
  },
  valid(state) {
    return validateTotalSpentGreaterThanCondition(state).valid;
  },
});

export { type TotalSpentGreaterThanState } from "@redotech/redo-model/return-flow/condition-validate";
